import makeStyles from '../../utils/makeStyles';

export default makeStyles()((theme) => ({
  chipWrapper: {
    display: 'inline-block',
    height: 22,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    textDecoration: 'none',
    position: 'relative',
    borderRadius: 4,
  },
  chipText: {
    fontFamily: theme.gh_vars.mabryMono,
    fontSize: 10,
    color: theme.palette.common.black,
    paddingBottom: 1,
    whiteSpace: 'nowrap',
  },
}));
